import script from "./UserWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./UserWallet.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__